import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Shield, Clock, Award, Users } from 'lucide-react';
import ContactForm from '../components/forms/ContactForm';

export default function AboutPage() {
  return (
    <>
      <Helmet>
        <title>О компании Проминнова - надежный поставщик трансформаторов</title>
        <meta
          name="description"
          content="Проминнова - ведущий поставщик трансформаторов ТСЛ и ТСЗ с опытом более 10 лет. 300+ успешных поставок, гарантия 36 месяцев, доставка по РФ и СНГ."
        />
      </Helmet>

      <div className="bg-primary-50 py-12">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Проминнова – ваш надежный поставщик трансформаторов и электрооборудования
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl">
            10 лет опыта, более 300 поставленных трансформаторов и тысячи довольных клиентов по всей
            России и СНГ
          </p>
        </div>
      </div>

      <div className="container-custom py-16">
        <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-16">
          <div className="p-8 md:p-12">
            <h2 className="text-3xl font-bold mb-6 text-primary-800">Наша миссия</h2>
            <div className="prose prose-lg max-w-none text-gray-700">
              <p>
                Мы создаём будущее, где технологии вдохновляют, объединяют и открывают безграничные
                возможности для каждого клиента и партнёра.
              </p>
              <p>
                Наша миссия — преобразовывать мир через инновации. Мы строим экосистему, где идеи
                превращаются в реальность, а вызовы становятся возможностями. Наша цель — создавать
                решения, которые решают задачи сегодня, и предвосхищают потребности завтра.
              </p>
              <p>
                С энтузиазмом и страстью мы разрабатываем и внедряем технологии, которые делают
                жизнь ярче, проще и эффективнее, поддерживая каждого на пути к великим достижениям.
                Наша компания — это сообщество экспертов и созидателей, где каждый клиент и партнёр
                становится частью большого, светлого и оптимистичного будущего.
              </p>
              <p className="text-xl font-semibold text-primary-700">
                Мы здесь, чтобы вместе с вами создавать мир, полный возможностей, где технологии
                служат людям, а партнёрства движут прогрессом!
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h2 className="text-3xl font-bold mb-6">О компании</h2>
            <p className="text-lg text-gray-600 mb-8">
              Обеспечиваем промышленность надежным оборудованием с экономией времени и бюджета. Мы
              не просто поставляем трансформаторы – мы помогаем нашим клиентам развивать их бизнес,
              предоставляя энергоэффективные решения и профессиональную поддержку на всех этапах
              сотрудничества.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <Shield className="w-10 h-10 text-primary-600 mb-4" />
                <div className="text-2xl font-bold mb-2">300+</div>
                <div className="text-gray-600">поставленных трансформаторов</div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <Clock className="w-10 h-10 text-primary-600 mb-4" />
                <div className="text-2xl font-bold mb-2">10 лет</div>
                <div className="text-gray-600">успешной работы</div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <Award className="w-10 h-10 text-primary-600 mb-4" />
                <div className="text-2xl font-bold mb-2">36 мес</div>
                <div className="text-gray-600">гарантии на оборудование</div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <Users className="w-10 h-10 text-primary-600 mb-4" />
                <div className="text-2xl font-bold mb-2">1000+</div>
                <div className="text-gray-600">довольных клиентов</div>
              </div>
            </div>

            <div className="space-y-4">
              <h3 className="text-2xl font-bold mb-4">Сертификаты и стандарты</h3>
              <div className="flex items-start space-x-4">
                <img
                  src="https://images.pexels.com/photos/8985454/pexels-photo-8985454.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                  alt="Сертификат ISO"
                  className="w-32 h-32 object-cover rounded-lg"
                  loading="lazy"
                  width="128"
                  height="128"
                />
                <div>
                  <h4 className="font-semibold mb-2">Сертификат ISO 9001:2015</h4>
                  <p className="text-gray-600">
                    Система менеджмента качества соответствует международным стандартам
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8">
              <h3 className="text-2xl font-bold mb-6">Свяжитесь с нами</h3>
              <ContactForm />
            </div>
          </div>
        </div>

        <div className="mt-16">
          <h2 className="text-3xl font-bold mb-8">Отзывы наших клиентов</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gray-200 rounded-full mr-4"></div>
                <div>
                  <div className="font-semibold">Михаил Соколов</div>
                  <div className="text-gray-500 text-sm">ООО "ЭнергоСтройПроект"</div>
                </div>
              </div>
              <p className="text-gray-600">
                "Сотрудничаем с Проминнова уже более 3 лет. За это время было поставлено более 20
                трансформаторов ТСЛ различной мощности. Оборудование отличается высоким качеством и
                надежностью."
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gray-200 rounded-full mr-4"></div>
                <div>
                  <div className="font-semibold">Анна Петрова</div>
                  <div className="text-gray-500 text-sm">АО "Горэлектросеть"</div>
                </div>
              </div>
              <p className="text-gray-600">
                "Заказали комплектную трансформаторную подстанцию КТПН-1000 для модернизации
                городской сети. Проект был реализован в срок, с соблюдением всех технических
                требований. Особенно отметили оперативность согласования документации."
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gray-200 rounded-full mr-4"></div>
                <div>
                  <div className="font-semibold">Дмитрий Волков</div>
                  <div className="text-gray-500 text-sm">ООО "ПромЭнергоСервис"</div>
                </div>
              </div>
              <p className="text-gray-600">
                "Работаем с Проминнова с 2020 года. За это время закупили 15 трансформаторов ТСЗ для
                промышленных объектов. Отличное соотношение цена-качество, профессиональная
                техническая поддержка и соблюдение сроков поставки."
              </p>
            </div>
          </div>
        </div>

        <div className="mt-16">
          <h2 className="text-3xl font-bold mb-8">Наши преимущества</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <Link to="/advantages" className="group">
              <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-all">
                <h3 className="text-xl font-semibold mb-4 group-hover:text-primary-600">
                  Экономия до 10% на электроэнергии
                </h3>
                <p className="text-gray-600">
                  Узнайте, как наши трансформаторы помогают снизить эксплуатационные расходы
                </p>
              </div>
            </Link>
            <Link to="/services" className="group">
              <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-all">
                <h3 className="text-xl font-semibold mb-4 group-hover:text-primary-600">
                  Комплексные решения
                </h3>
                <p className="text-gray-600">
                  От проектирования до монтажа и сервисного обслуживания
                </p>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
